import { Box, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import React, { FC, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { PerOrderSendInvoiceAction } from 'models/order';

type PerOrderInvoiceActionModuleProps = {
    action: PerOrderSendInvoiceAction;
    onChange: (action: PerOrderSendInvoiceAction) => void;
    disabled?: boolean;
    canCreateInvoice: boolean;
};

/** DD-3387: the invoicing choice for a per-order-invoice clinic in the send dialog. */
const PerOrderInvoiceActionModule: FC<PerOrderInvoiceActionModuleProps> = ({
    action,
    onChange,
    disabled,
    canCreateInvoice,
}: PerOrderInvoiceActionModuleProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value as PerOrderSendInvoiceAction);
    };

    return (
        <Box>
            <FormControl component="fieldset">
                <RadioGroup row onChange={handleChange} value={action}>
                    <FormControlLabel
                        value={PerOrderSendInvoiceAction.DO_NOTHING}
                        disabled={disabled}
                        control={<Radio color="secondary" data-test="per-order-invoice-action.do-nothing-radio" />}
                        label={translate('orders:INVOICE_DO_NOTHING')}
                    />
                    <FormControlLabel
                        value={PerOrderSendInvoiceAction.CREATE_INVOICE}
                        disabled={disabled || !canCreateInvoice}
                        control={<Radio color="secondary" data-test="per-order-invoice-action.create-invoice-radio" />}
                        label={translate('invoices:CREATE_INVOICE')}
                    />
                    <FormControlLabel
                        value={PerOrderSendInvoiceAction.SHOULD_NOT_INVOICE}
                        disabled={disabled}
                        control={<Radio color="secondary" data-test="per-order-invoice-action.do-not-invoice-radio" />}
                        label={translate('orders:DO_NOT_INVOICE')}
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default PerOrderInvoiceActionModule;
